import { Settings } from "../../../Settings";
import Path from "../Path";
import PathPlanJumpLeft from "../plan/PathPlanJumpLeft";
import PathPlanJumpRight from "../plan/PathPlanJumpRight";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternJump0Side4 extends PathTemplatePattern {
    constructor() {
        super([
            '.OOO.',     // ignore open   open    open   ignore
            'S8.8E',     // start  o|p    o|p     o|p    end
            'X8.8.'     //  closed o|p    .       o|p    closed
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 4;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() + 4; // end tile is 4 columns to the right of start
        const targetRow = start.getTileRow();     // end tile is on same row as start
        const endIndex = this.findTilePathIndex(path, pathIndex + 4, targetCol, targetRow);  // +4: we know the end is at least 4 steps away in the path.
        if (endIndex < 0) {
            console.log('PatternJump0Side4 getPathPlan failed to find end index');
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpRight(start, end, steps, Settings.tile.size);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        
        const targetCol = start.getTileCol() - 4; // end tile is 4 columns to the left of start
        const targetRow = start.getTileRow();     // end tile is on same row as start
        const endIndex = this.findTilePathIndex(path, pathIndex + 4, targetCol, targetRow);  // +4: we know the end is at least 4 steps away in the path.
        if (endIndex < 0) {
            console.log('PatternJump0Side4 getPathPlanFlipped failed to find end index');
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpLeft(start, end, steps, Settings.tile.size);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternJump0Side4';
    }
}